
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/partnerize",
      function () {
        return require("private-next-pages/destinations/partnerize.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/partnerize"])
      });
    }
  